import { render, staticRenderFns } from "./CollectRecharge.vue?vue&type=template&id=5d7a325a&scoped=true"
import script from "./CollectRecharge.vue?vue&type=script&lang=js"
export * from "./CollectRecharge.vue?vue&type=script&lang=js"
import style0 from "./CollectRecharge.vue?vue&type=style&index=0&id=5d7a325a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a325a",
  null
  
)

export default component.exports